<template>
  <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <BackButton @back="back('submit-request')" />
    <v-card class="mb-1">
      <v-card-title primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <div>
          <v-text-field
            placeholder="Excess payment made for what"
            label="Excess Payment Made for What"
            v-model="excessPaymentMadeFor"
            outlined
            color
          ></v-text-field>
          <div class="md:flex">
            <v-text-field
              class="mr-2"
              placeholder="Amount"
              label="Amount"
              v-model="amount"
              outlined
              color
            ></v-text-field>
            <v-text-field
              placeholder="Mode of payment"
              label="Mode of payment"
              v-model="modeOfPayment"
              outlined
              color
            ></v-text-field>
          </div>
          <div class="w-full border border-gray-500 rounded px-4 py-2">
            <textarea
              name="Justification"
              class="w-full border border-gray-700 outline-none"
              placeholder="Justification"
              label="Justification"
              v-model="justification"
              rows="5"
            ></textarea>
          </div>
          <div>{{ note1 }}</div>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mb-1">
      <v-card-title primary-title>
        {{ title2 }}
      </v-card-title>
      <v-card-text>
        <div>
          {{ note2 }}
        </div>
        <div class="w-full">
          <div class="my-1 flex items-center">
            <div class="border border-gray-500 w-3/4 mr-2">
              <input type="text" class="w-full px-4 py-2" />
            </div>
            <v-btn class="1/4" color="lightblue">Add attachment</v-btn>
          </div>
          <div class="justify-end flex">
            <v-btn small elevation="" dark color="blue">
              <v-icon>mdi-plus</v-icon>
              Add more</v-btn
            >
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="my-1">
      <v-card-text>
        <div>
          <v-card-title primary-title> Reminders and guidelines </v-card-title>
          <ul>
            <li>
              Your account and payments made will be validated first to confirm
              of there is indeed excess payment.
            </li>
            <li>
              2. In the event excess payment is reflected but you have other
              further payments due, the excess payment will be credited towards
              your other payments due.
            </li>
            <li>
              3. Once submitted, you may see the status of your request on your
              Dashboard
            </li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
    <AlertDialog
      :showAlert="showAlert"
      @alertDialogSubmit="alertDialogSubmit"
    />
    <div class="my-2 w-full">
      <v-btn @click="submit" class="w-full" color="blue"> Submit Request</v-btn>
    </div>
  </div>
</template>

<script>
import BackButton from "@/common/BackButton.vue";
import AlertDialog from "../../common/AlertDialog.vue";
export default {
  data() {
    return {
      justification: "",
      amount: "",
      modeOfPayment: "",
      excessPaymentMadeFor: null,
      title: "Refund Excess Payment",
      title2: "Add a brief description of the attached file",
      note1:
        "Any separate requests indicated in the ‘Justification’ will not be acknowledged for processing.",
      note2:
        "All attached files shall be for the purpose of showing supporting data only for your appeal.Any separate requests indicated in the attached files will not be acknowledged for processing.",
      showAlert: false,
    };
  },
  components: {
    AlertDialog,
    BackButton,
  },
  methods: {
    back(n) {
      this.$router.push({ name: n });
    },
    submit() {
      this.showAlert = true;
    },
    alertDialogSubmit(name) {
      this.showAlert = false;
      !this.$route.path.includes(name) ? this.$router.push(name) : null;
    },
  },
};
</script>